<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name" 
    [autoClearSearch]="false" [(ngModel)]="productType" placeholder="Seleccionar Producto" (select)="changeProductType($event)">

    <ng-template ngx-select-option let-option>
        <span [class.selected]="isSelected(option)" [class.ngx-select-option-selected]="isSelected(option)">{{option.text}}</span>
    </ng-template>

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrado
    </ng-template>

</ngx-select>